var _excluded = ["component", "componentProps", "route", "link", "redirect", "from", "viewMode", "user", "setViewMode", "handleFullScreen", "appMaintenanceStatus"],
  _excluded2 = ["component", "route", "redirect", "from"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import SideMenu from "../SideMenu";
import jwtDecode from "jwt-decode";
import { getAuth } from "../utils";
export var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
    _ref$componentProps = _ref.componentProps,
    componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
    Route = _ref.route,
    Link = _ref.link,
    Redirect = _ref.redirect,
    from = _ref.from,
    viewMode = _ref.viewMode,
    user = _ref.user,
    setViewMode = _ref.setViewMode,
    handleFullScreen = _ref.handleFullScreen,
    appMaintenanceStatus = _ref.appMaintenanceStatus,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Route, _extends({}, props, {
    render: function render(renderProps) {
      var auth = getAuth();
      if (auth) {
        var _tokenDecoded$organis, _tokenDecoded$organis2, _localStorage, _localStorage$getItem;
        var tokenDecoded = jwtDecode(auth);
        var onboardProcessCheck = tokenDecoded === null || tokenDecoded === void 0 ? void 0 : (_tokenDecoded$organis = tokenDecoded.organisations) === null || _tokenDecoded$organis === void 0 ? void 0 : (_tokenDecoded$organis2 = _tokenDecoded$organis[0]) === null || _tokenDecoded$organis2 === void 0 ? void 0 : _tokenDecoded$organis2.userOnboardStatus;
        // const role = tokenDecoded?.organisations[0]?.teams[0]?.role?.roleName;
        // console.log(role); role === "Admin" &&

        var prevPageLink = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$getItem = _localStorage.getItem) === null || _localStorage$getItem === void 0 ? void 0 : _localStorage$getItem.call(_localStorage, "prevLink");
        if (prevPageLink !== null) {
          var _localStorage2, _localStorage2$remove;
          (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$remove = _localStorage2.removeItem) === null || _localStorage2$remove === void 0 ? void 0 : _localStorage2$remove.call(_localStorage2, "prevLink");
        }
        if (onboardProcessCheck === "Onboard Process Incompleted") {
          return /*#__PURE__*/React.createElement(Component, _extends({
            link: Link,
            redirect: Redirect
          }, renderProps, componentProps, {
            from: from,
            handleFullScreen: handleFullScreen
          }));
        }
        return /*#__PURE__*/React.createElement(SideMenu, _extends({
          from: from,
          viewMode: from !== "web" ? viewMode : null,
          handleFullScreen: from !== "web" ? handleFullScreen : null,
          setViewMode: from !== "web" ? setViewMode : null,
          linkComponent: Link,
          linkAttribute: "to",
          prevPageLink: prevPageLink
        }, renderProps), /*#__PURE__*/React.createElement(Component, _extends({
          link: Link,
          redirect: Redirect
        }, renderProps, componentProps, {
          from: from,
          handleFullScreen: handleFullScreen,
          appMaintenanceStatus: appMaintenanceStatus,
          viewMode: viewMode,
          setViewMode: setViewMode,
          userId: user === null || user === void 0 ? void 0 : user.userId
        })));
      }
      return /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: "/login",
          state: {
            from: renderProps.location
          }
        }
      });
    }
  }));
};
export var PublicRoute = function PublicRoute(_ref2) {
  var Component = _ref2.component,
    Route = _ref2.route,
    Redirect = _ref2.redirect,
    from = _ref2.from,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Route, _extends({}, props, {
    render: function render(renderProps) {
      var auth = getAuth();
      if (!auth || props.path == "/workfolio-affiliates" || props.path == "/workfolio-maintenance" || props.path == "/privacy-policy") {
        return /*#__PURE__*/React.createElement(Component, _extends({}, renderProps, {
          from: from
        }));
      } else {
        var _tokenDecoded$organis3, _tokenDecoded$organis4, _tokenDecoded$organis5, _tokenDecoded$organis6, _tokenDecoded$organis7, _tokenDecoded$organis8;
        var tokenDecoded = jwtDecode(auth);
        var onboardProcessCheck = tokenDecoded === null || tokenDecoded === void 0 ? void 0 : (_tokenDecoded$organis3 = tokenDecoded.organisations) === null || _tokenDecoded$organis3 === void 0 ? void 0 : (_tokenDecoded$organis4 = _tokenDecoded$organis3[0]) === null || _tokenDecoded$organis4 === void 0 ? void 0 : _tokenDecoded$organis4.userOnboardStatus;
        //const role = tokenDecoded?.organisations[0]?.teams[0]?.role?.roleName;

        var projectManagementStatus = tokenDecoded === null || tokenDecoded === void 0 ? void 0 : (_tokenDecoded$organis5 = tokenDecoded.organisations) === null || _tokenDecoded$organis5 === void 0 ? void 0 : (_tokenDecoded$organis6 = _tokenDecoded$organis5[0]) === null || _tokenDecoded$organis6 === void 0 ? void 0 : _tokenDecoded$organis6.projectFeatureStatus;

        // if (
        //   tokenDecoded?.organisations[0]?.userRole == "Member" &&
        //   from !== "desktop" &&
        //   projectManagementStatus == true
        // ) {
        //   return <Redirect to="/task-overview" />;
        // }

        // console.log("enter");

        if ((tokenDecoded === null || tokenDecoded === void 0 ? void 0 : (_tokenDecoded$organis7 = tokenDecoded.organisations) === null || _tokenDecoded$organis7 === void 0 ? void 0 : (_tokenDecoded$organis8 = _tokenDecoded$organis7[0]) === null || _tokenDecoded$organis8 === void 0 ? void 0 : _tokenDecoded$organis8.userRole) == "Member" && from !== "desktop") {
          return /*#__PURE__*/React.createElement(Redirect, {
            to: "/my-work"
          });
        }
        if (onboardProcessCheck === "Onboard Process Incompleted") {
          var _tokenDecoded$organis9, _tokenDecoded$organis10;
          return /*#__PURE__*/React.createElement(Redirect, {
            to: {
              pathname: "/on-boarding/".concat(tokenDecoded === null || tokenDecoded === void 0 ? void 0 : (_tokenDecoded$organis9 = tokenDecoded.organisations) === null || _tokenDecoded$organis9 === void 0 ? void 0 : (_tokenDecoded$organis10 = _tokenDecoded$organis9[0]) === null || _tokenDecoded$organis10 === void 0 ? void 0 : _tokenDecoded$organis10.planType),
              state: {
                from: "login"
              }
            }
          });
        }
        //}

        if (from !== "desktop") {
          var _localStorage3, _localStorage3$setIte;
          (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : (_localStorage3$setIte = _localStorage3.setItem) === null || _localStorage3$setIte === void 0 ? void 0 : _localStorage3$setIte.call(_localStorage3, "prevLink", props.location.pathname);
        }
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }
    }
  }));
};